import React, { useState } from 'react';

// Controlled numeric input that allows free typing and only clamps
// to min/max on blur — clamping per-keystroke made fields with a high
// `min` (e.g. BTC Price min=10000) impossible to edit.
function Input({ label, value, onChange, min, max, step = 1, id }) {
  const inputId = id || label?.replace(/\s+/g, '-').toLowerCase();
  const [draft, setDraft] = useState(null); // null = not editing, show `value`

  const commit = (raw) => {
    const num = Number(raw);
    if (raw === '' || isNaN(num)) return; // keep previous value
    const clamped = Math.min(max ?? num, Math.max(min ?? num, num));
    onChange(clamped);
  };

  return (<div className="min-w-0">
    <label htmlFor={inputId} className="block mb-1.5 font-medium" style={{ color: '#525252', textTransform: 'uppercase', letterSpacing: '1px', fontSize: '11px', fontFamily: "'IBM Plex Mono', monospace" }}>{label}</label>
    <input id={inputId} type="number" value={draft ?? value} min={min} max={max} step={step}
      aria-label={label}
      onChange={(e) => setDraft(e.target.value)}
      onKeyDown={(e) => { if (e.key === 'Enter') { commit(e.target.value); setDraft(null); e.target.blur(); } }}
      className="w-full px-3 py-2.5 text-sm transition-all"
      style={{ background: '#F5F5F5', border: '1px solid #D4D4D4', borderRadius: '4px', color: '#1A1A1A', fontVariantNumeric: 'tabular-nums', fontFamily: "'IBM Plex Mono', monospace", outline: '2px solid transparent', outlineOffset: '2px' }}
      onFocus={(e) => { e.target.style.outline = '2px solid #2563EB'; e.target.style.borderColor = '#2563EB'; }}
      onBlur={(e) => {
        e.target.style.outline = '2px solid transparent'; e.target.style.borderColor = '#D4D4D4';
        commit(e.target.value); setDraft(null);
      }}
    />
  </div>);
}

export default Input;
